import api from "api/axios";

export const fetchOrganizerEvents = (companyId) =>
  api.get(`/company-event/company/${companyId}`);

export const fetchOrganizerEventsById = (companyId) =>
  api.get(`/company-event/${companyId}`);

export const createEvent = (data) =>
  api.post("/company-event/", data);

export const updateEvent = (id, data) =>
  api.put(`/company-event/${id}`, data);

export const deleteEvent = (id, payload) =>
  api.delete(`/company-event/${id}`, { data: payload });